/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Author_PlaceholderInputs */

const en_admin_posts_author_placeholder = /** @type {(inputs: Admin_Posts_Author_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author name`)
};

/**
* | output |
* | --- |
* | "Author name" |
*
* @param {Admin_Posts_Author_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_author_placeholder = /** @type {((inputs?: Admin_Posts_Author_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Author_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_author_placeholder(inputs)
});
export { admin_posts_author_placeholder as "admin.posts.author_placeholder" }